import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/contact-messages/:messageId/respond/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const respond = {
  post: apiPathFunc(pathBase),
} as const;
